export default "__VITE_ASSET__CM09J3KH__"